import React from 'react';
// import { Select, MenuItem } from '@mui/material';
import SelectBoxArrowDown from '../../../assets/icons/selectBoxArrowDown.svg';
import SelectBoxArrowUp from '../../../assets/icons/selectBoxArrowUp.svg';

// Custom arrow icon logic
export const CustomArrowIcon = (props) => {
  const [open, setOpen] = React.useState(false);

  // Toggles open/close state
  React.useEffect(() => {
    const selectNode = document.querySelector('.MuiSelect-select');
    if (selectNode) {
      selectNode.addEventListener('click', () => setOpen(!open));
    }
    return () => {
      if (selectNode) {
        selectNode.removeEventListener('click', () => setOpen(!open));
      }
    };
  }, [open]);

  return open ? (
    <img
      src={SelectBoxArrowUp}
      alt="Up Arrow"
      style={{ width: '1rem', height: '1rem' }}
      {...props}
    /> // Use "up" arrow when open
  ) : (
    <img
      src={SelectBoxArrowDown}
      alt="Down Arrow"
      style={{ width: '1rem', height: '1rem' }}
      {...props}
    /> // Use "down" arrow when closed
  );
};

export default CustomArrowIcon;
